module.exports = __webpack_public_path__ + "static/media/es_flag.ac31e838.svg";